<template>
  <v-card>
    <v-container fluid grid-list-sm>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{ labels.cedant }}</v-subheader>
            <div class="subheading" v-if="form.cedant">{{ form.cedantName }}</div>
            <div class="subheading" v-else>-</div>
          </v-flex>
          <v-flex sm3 xs12 v-if="form.clmStat === 'C' || mode === 'query' || !form.cedant">
            <v-subheader class="queryLabel">{{ labels.cedClmNo }}</v-subheader>
            <div class="subheading" v-if="form.cedClmNo">{{ form.cedClmNo }}</div>
            <div class="subheading" v-else>-</div>
          </v-flex>
          <v-flex sm3 xs12 v-else>
            <v-text-field
              v-model="form.cedClmNo"
              :label="labels.cedClmNo"
              data-vv-scope="cedant"
              data-vv-name="form.cedClmNo"
              :data-vv-as="labels.cedClmNo"
              :error-messages="errors.collect('form.cedClmNo')"
              v-validate="'max:16|required'"
            />
          </v-flex>
          <v-flex sm4 xs12 v-if="form.clmStat === 'C' || mode === 'query' || !form.cedant">
            <v-subheader class="queryLabel">{{ labels.recip }}</v-subheader>
            <div class="subheading">
              {{
                form.recip === 'Y' || form.recip === 'y'
                  ? 'Yes'
                  : form.recip === 'N' || form.recip === 'n'
                  ? 'No'
                  : form.recip === 'C' || form.recip === 'c'
                  ? 'Consortium'
                  : '-'
              }}
            </div>
          </v-flex>
          <v-flex sm3 xs12 v-else>
            <v-select
              :items="recipList"
              v-model="form.recip"
              :label="labels.recip"
              item-text="label"
              item-value="value"
              data-vv-scope="cedant"
              data-vv-name="recip"
              :data-vv-as="labels.recip"
              :error-messages="errors.collect('recip')"
              :clearable="false"
            />
          </v-flex>
          <v-flex xs12 class="ma-0 pa-0" />
          <v-flex sm4 xs12>
            <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
            <div class="subheading" v-if="form.cedPolNo">{{ form.cedPolNo }}</div>
            <div class="subheading" v-else>-</div>
          </v-flex>
          <v-flex xs12 class="ma-0 pa-0" />
          <v-flex sm4 xs12>
            <v-subheader class="queryLabel">{{ labels.cedCesNo }}</v-subheader>
            <div class="subheading" v-if="form.cedCesNo">{{ form.cedCesNo }}</div>
            <div class="subheading" v-else>-</div>
          </v-flex>
          <v-flex xs12 class="ma-0 pa-0" />
          <v-flex sm3 xs12>
            <v-subheader class="queryLabel">{{ labels.appCoins }}</v-subheader>
            <div class="subheading">{{ form.appCoins ? 'Yes' : 'No' }}</div>
          </v-flex>
          <v-flex sm3 xs12>
            <v-subheader class="queryLabel">{{ labels.billCoins }}</v-subheader>
            <div class="subheading" v-if="form.billCoins">{{ form.billCoins }}</div>
            <div class="subheading" v-else>-</div>
          </v-flex>
          <v-flex sm3 xs12>
            <v-subheader class="queryLabel">{{ labels.coInsPct }}</v-subheader>
            <div class="subheading">{{ formatDisplayNumber(form.coInsPct || 0.0, 6) + ' %' }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      recipList: [
        { label: 'Y - Yes', value: 'Y' },
        { label: 'N - No', value: 'N' },
        { label: 'C - Consortium', value: 'C' }
      ],
      labels: {
        cedant: 'Ceding Co.',
        cedClmNo: 'CC Claim No.',
        recip: 'Recip',
        cedPolNo: 'CC Policy No.',
        cedCesNo: 'CC Cesion No.',
        appCoins: 'Coinsurance',
        billCoins: 'Bill Coinsurer',
        coInsPct: 'Coinsurance %'
      }
    }
  },
  props: {
    mode: {
      type: String,
      default: 'review'
    },
    form: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    resCurrList() {
      return this.$store.state.claims.claimParams.resCurrList
    }
  },
  methods: {
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    assignCurrency(data) {
      this.form.resCurr = data.curr
    }
  },
  components: {}
}
</script>

<style>
</style>
